import React, { useState, useEffect } from "react";

/** Components */
import {
  TableContainer,
  Autocomplete,
  TableHead,
  TableRow,
  TextField,
  TableCell,
  TableBody,
  Table,
  Paper,
  TablePagination,
  Button,
  Checkbox,
  ButtonGroup,
  TableFooter,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import SelectStatusButton, { statusOptions } from "./../../commons/SelectStatusButton";

import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
// import AddIcon from "@mui/icons-material/Add";

/** Api & Function */
import {
  // createProvider,
  getProvider,
  postSync,
  updateProvider,
  updateProviderStatus,
} from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
/** Package */

/** Hook */
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { setDataFromBEState } from "../../../store/dataFromBESlice";

const initialFilter = {
  status: null,
  name: "",
};
const headerName = ["ID", "Tên", "Tên ngắn", "Tax", "Địa chỉ", "Trạng thái"];

const Provider = () => {
  //boiler plate
  const [t] = useTranslation();
  const dispatch = useDispatch();

  //redux state
  const data = useSelector((state) => state.data.provider);

  //state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [changeIds, setChangeIds] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  //filter
  const [filter, setFilter] = useState({ ...initialFilter });
  const [isOpen, setOpen] = useState(false);

  //effect
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN ĐƠN VỊ VẬN CHUYỂN"));
    if (!data)
      getProvider().then((res) => {
        res.code === 200 && dispatch(setDataFromBEState({ provider: res.data }));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setPage(0);
  }, [filter]);

  //method
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return updateProviderStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      dispatch(setDataFromBEState({ provider: data.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)) }));
    }
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleSuccessEdit = (res) => {
    dispatch(setDataFromBEState({ provider: data.map((item) => (item.id === res.data.id ? res.data : item)) }));
    setSelectedRow(null);
  };
  //render
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button onClick={() => setOpen((prev) => !prev)}>
            <SearchIcon />
          </Button>
          <ButtonWithAPICallComponent title="Đồng bộ dữ liệu" api={() => postSync({ object: "provider" })}>
            <RefreshIcon />
          </ButtonWithAPICallComponent>
        </ButtonGroup>
      </div>
      <Collapse in={isOpen} sx={{ marginBottom: "20px" }}>
        <TextField sx={{ margin: "5px" }} value={filter.name} onChange={(e) => setFilter((prev) => ({ ...prev, name: e.target.value }))} label={t("Tên")} />
        <Autocomplete
          sx={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
          options={statusOptions}
          getOptionLabel={(option) => t(option.label) || ""}
          value={filter.value}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, status: newValue }))}
          renderInput={(params) => <TextField {...params} label={t("Trạng thái")} />}
        />{" "}
      </Collapse>
      {!data ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {headerName.map((item, index) => (
                  <TableCell style={{ border: "0.5px solid lightgray" }} key={index}>
                    {t(item)}
                  </TableCell>
                ))}
                <TableCell style={{ border: "0.5px solid lightgray" }}>
                  <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                .filter((item) => item.name.contains(filter.name) && (filter.status === null ? true : item.status === filter.status.label))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length ? (
                data
                  .filter((item) => item.name.contains(filter.name) && (filter.status === null ? true : item.status === filter.status.label))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => <Row key={index} row={row} onCheckboxClick={() => handleCheckBoxClick(row.id)} checked={changeIds.includes(row.id)} onClick={() => setSelectedRow(row)} />)
              ) : (
                <TableRow>
                  <TableCell colSpan={9}>{t("Không có dữ liệu")}</TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  count={data.filter((item) => item.name.contains(filter.name) && (filter.status === null ? true : item.status === filter.status.label)).length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}

      {/* hidden stuff */}
      <EditDialog
        open={Boolean(selectedRow)}
        onSuccess={handleSuccessEdit}
        onClose={() => {
          setSelectedRow(null);
        }}
        initialData={selectedRow}
      />
    </div>
  );
};

export default Provider;

// const CreateButton = ({ onSuccess, ...buttonProps }) => {
//   const [open, setOpen] = useState(false);
//   const [t] = useTranslation();
//   const [inputData, setInputData] = useState({
//     name: "",
//     shortname: "",
//     email: "",
//     tax_code: "",
//     address: "",
//   });
//   const handleCreate = () => {
//     return createProvider(inputData);
//   };
//   const handleResponse = (res) => {
//     if (res.code === 200) {
//       setOpen(false);
//       onSuccess && onSuccess(res);
//     }
//   };
//   return (
//     <React.Fragment>
//       <Button {...buttonProps} variant="outlined" onClick={() => setOpen((prev) => !prev)}>
//         <AddIcon />
//       </Button>
//       <Dialog open={open} onClose={() => setOpen(false)}>
//         <DialogTitle align="center">{t("Tạo đơn vị vận chuyển")}</DialogTitle>
//         <DialogContent align="center">
//           <TextField label={t("Tên")} value={inputData.name} onChange={(e) => setInputData((prev) => ({ ...prev, name: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
//           <TextField label={t("Tên ngắn")} value={inputData.shortname} onChange={(e) => setInputData((prev) => ({ ...prev, shortname: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
//           <TextField label="Email" value={inputData.email} onChange={(e) => setInputData((prev) => ({ ...prev, email: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
//           <TextField label="Tax" value={inputData.tax_code} onChange={(e) => setInputData((prev) => ({ ...prev, tax_code: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
//           <TextField label={t("Địa chỉ")} value={inputData.address} onChange={(e) => setInputData((prev) => ({ ...prev, address: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpen(false)}>{t("Hủy")}</Button>
//           <ButtonWithAPICallComponent variant="contained" api={handleCreate} response={handleResponse}>
//             {t("Tạo mới")}
//           </ButtonWithAPICallComponent>
//         </DialogActions>
//       </Dialog>
//     </React.Fragment>
//   );
// };
const Row = ({ row, onClick, onCheckboxClick, checked = false }) => {
  const [t] = useTranslation();
  return (
    <React.Fragment>
      <TableRow
        hover={row.status !== "DELETED"}
        onClick={(e) => e.target.type !== "checkbox" && row.status !== "DELETED" && onClick && onClick(row)}
        style={{
          cursor: row.status !== "DELETED" && "pointer",
        }}
      >
        <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id} </TableCell>
        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
          {row.name}
        </TableCell>
        <TableCell style={{ border: "0.5px solid lightgray" }}>{row.shortname}</TableCell>
        <TableCell style={{ border: "0.5px solid lightgray" }}>{row.tax_code}</TableCell>
        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
          {row.address}
        </TableCell>
        <TableCell style={{ border: "0.5px solid lightgray" }} className={`status ${row.status}`}>
          {t(row.status)}
        </TableCell>
        <TableCell style={{ border: "0.5px solid lightgray" }}>
          <Checkbox checked={checked} disabled={row.status === "DELETED"} onClick={onCheckboxClick} />
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
const EditDialog = ({ open, onClose, onSuccess, initialData }) => {
  const [t] = useTranslation();
  const [inputData, setInputData] = useState(initialData);

  useEffect(() => {
    setInputData(initialData);
  }, [initialData]);
  const handleSave = () => {
    return updateProvider(initialData.id, inputData);
  };
  const handleResponse = (res) => {
    if (res.code === 200) {
      onSuccess && onSuccess(res);
    }
  };
  if (inputData)
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle align="center">{t("Chỉnh sửa đơn vị vận chuyển")}</DialogTitle>
        <DialogContent align="center" style={{ paddingTop: 10 }}>
          <TextField label={t("Tên")} value={inputData.name} onChange={(e) => setInputData((prev) => ({ ...prev, name: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
          <TextField label={t("Tên ngắn")} value={inputData.shortname} onChange={(e) => setInputData((prev) => ({ ...prev, shortname: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
          <TextField label="Email" value={inputData.email} onChange={(e) => setInputData((prev) => ({ ...prev, email: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
          <TextField label="Tax" value={inputData.tax_code} onChange={(e) => setInputData((prev) => ({ ...prev, tax_code: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
          <TextField label={t("Địa chỉ")} value={inputData.address} onChange={(e) => setInputData((prev) => ({ ...prev, address: e.target.value }))} fullWidth sx={{ margin: "5px 0" }} />
          <div style={{ padding: "10px", display: "flex" }}>
            <div style={{ margin: "auto" }}></div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{t("Hủy")}</Button>
          <ButtonWithAPICallComponent variant="contained" api={handleSave} response={handleResponse}>
            {t("Lưu")}
          </ButtonWithAPICallComponent>
        </DialogActions>
      </Dialog>
    );
  else return "";
};
